const onMessageSelectHandler =
  ({options, onQuerySelect}) =>
  ({key}) => {
    const option = [...options].find(({id}) => id === key) || null;
    if (!option) return;
    onQuerySelect(option);
  };

export default onMessageSelectHandler;
